import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getHotels, deleteHotels } from "services/HotelService";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { useAuth } from "hooks/useAuth";

const HotelsList = () => {

  const [hotels, setHotels] = useState([]);
  const [hotel, setHotel] = useState({});
  const [filteredHotels, setFilteredHotels] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [deleteHotelId, setDeleteHotelId] = useState(null);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();
  const { hasPermission } = useAuth();

  useEffect(() => {
    getHotelsList();
  }, []);

  useEffect(() => {
    handleSearch();
  }, [searchQuery, hotels]);

  const getHotelsList = () => {
    getHotels().then((response) => {
      if (response && response.data.success) {
        setHotels(response.data.hotels);
        setFilteredHotels(response.data.hotels);
      }
    });
  };

  const handleSearch = () => {
    const query = searchQuery.toLowerCase();
    const filtered = hotels.filter(
      (hotel) =>
        hotel.name?.toLowerCase().includes(query) ||
        hotel.email?.toLowerCase().includes(query) ||
        hotel.contact_number?.toLowerCase().includes(query)
    );
    setFilteredHotels(filtered);
    setPage(0);
  };

  const handleChangePage = (newPage) => setPage(newPage);
  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const paginatedHotels = filteredHotels.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );

  const handleCreate = () => {
    navigate("/add-hotel", { state: { isEdit: false } });
  };

  const handleEdit = (hotel) => {
    navigate("/add-hotel", { state: { isEdit: true, editFormData: hotel } });
  };

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this coupon?")) {
      //dispatch(deleteCouponAction(id));
    }
  };

  const exportToCSV = () => {
    const csvData = filteredHotels.map((hotel) => ({
      "Hotel Name": hotel.name,
      "State": hotel.state,
      "Contact Person": hotel.contact_person_name,
      "Contact Number": hotel.contact_number,
      "Category": hotel.category,
    }));
  
    const worksheet = XLSX.utils.json_to_sheet(csvData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Hotels");
  
    const csvOutput = XLSX.write(workbook, {
      bookType: "csv",
      type: "array",
    });
  
    const blob = new Blob([csvOutput], { type: "text/csv;charset=utf-8;" });
    saveAs(blob, "hotels_list.csv");
  };
  
  const exportToXLS = () => {
    const xlsData = filteredHotels.map((hotel) => ({
      "Hotel Name": hotel.name,
      "State": hotel.state,
      "Contact Person": hotel.contact_person_name,
      "Contact Number": hotel.contact_number,
      "Category": hotel.category,
      
    }));  
    const worksheet = XLSX.utils.json_to_sheet(xlsData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Hotels");
  
    const xlsOutput = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
  
    const blob = new Blob([xlsOutput], {
      type:
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
  
    saveAs(blob, "hotels_list.xlsx");
  };

  const showHotel = (hotel) => {
    setHotel(hotel);
  };

  const deleteHotel = (id) => {
    setDeleteHotelId(id);
    setShowDeleteModal(true);
  };
  const confirmDeleteHotel = () => {
    deleteHotels(deleteHotelId).then((response) => {
      if (response && response.data.success) {
        setShowDeleteModal(false);
        getHotelsList();
      }
    });
    //setDeleteHotelId(deleteHotelId);
  };

  return (
    <>
      <section className="content-header">
        <div class="header-icon">
          <i class="fa fa-hotels"></i>
        </div>
        <div className="header-title">
          <h1>Manage Hotels</h1>
          <small>Hotels List</small>
        </div>
      </section>

      <section className="content">
        <div className="row">
          <div className="col-lg-12 pinpin">
            <div className="buttonexport" id="buttonlist">
            {hasPermission("Add Hotel") && (
              <Link className="btn btn-add" to="/add-hotel">              
                <i className="fa fa-plus"></i> Add Hotel
              </Link>
            )}
            </div>
            <div className="card lobicard mt-2" data-sortable="true">
              <div className="card-header">
                <div className="card-title custom_title">
                  <h4>Hotels List</h4>
                </div>
              </div>
              <div className="card-body">

              <div className="d-flex align-items-center mb-3">
                  <select
                    value={rowsPerPage}
                    onChange={handleRowsPerPageChange}
                    className="form-control w-auto mr-3"
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </select>

                  <input
                    type="text"
                    placeholder="Search by name, company name, email, or phone"
                    className="form-control w-25 mr-3"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <div className="btn-group ml-3">
                    <button
                      className="btn btn-exp btn-sm "
                      data-toggle="dropdown"
                    >
                      <i className="fa fa-bars"></i> Export Table Data
                    </button>
                    <ul className="dropdown-menu exp-drop" role="menu">
                      <li>
                        <a
                          href="#"
                          onClick={exportToCSV}
                        >
                          <img
                            src="assets/dist/img/csv.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          CSV
                        </a>
                      </li>

                      <li class="dropdown-divider"></li>
                      <li>
                        <a
                          href="#"
                          onClick={exportToXLS}
                        >
                          <img
                            src="assets/dist/img/xls.png"
                            width="24"
                            alt="logo"
                          />{" "}
                          XLS
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <hr />

                <div className="table-responsive">
                  <table
                    id="dataTableExample1"
                    className="table table-bordered table-striped table-hover"
                  >
                    <thead className="back_table_color">
                    <tr class="info">                          
                          <th>Hotel Name</th>
                          <th>State</th>
                          <th>Category </th>
                          <th>Contact Number </th>
                          <th>Contact Person </th>                         
                          <th>View </th>
                          <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                    { filteredHotels.length > 0 ? (
                      filteredHotels.map((hotel) => (
                          <tr key={hotel.id}>
                          <td>{hotel.name} </td>
                          <td>{hotel.state}</td>
                          <td>{hotel.category} Star</td>
                          <td>{hotel.contact_person_name}</td>
                          <td>{hotel.contact_number}</td>
                       
                          <td>
                          {hasPermission("View Hotel") && (
                            <button type="button" className="btn btn-primary btn-sm" data-toggle="modal" data-target="#hotelInfo" onClick={()=>{ showHotel(hotel); }}><i className="fa fa-eye"></i> </button>
                          )}
                            </td>
                          
                        <td>
                        {hasPermission("Edit Hotel") && (
                        <button type="button" className="btn btn-add btn-sm" data-toggle="modal" data-target="#customer1" onClick={(e) => {
                                
                                  handleEdit(hotel);
                                }}><i className="fa fa-pencil"></i></button>
                              )}
                          {hasPermission("Delete Hote") && (    
                         <button type="button" className="btn btn-danger btn-sm" data-toggle="modal" data-target="#customer2" onClick={(e) => {                                 
                                  deleteHotel(hotel.id);
                                }}><i className="fa fa-trash-o"></i> </button>
                              )}
                        </td>
                      </tr>
                       ))
                      ) : (
                        <tr>
                          <td colSpan="7" className="text-center">
                            No hotels found.
                          </td>
                        </tr>
                      )}      
                    </tbody>
                  </table>
                </div>
               {/* Pagination Controls */}
               <div className="d-flex justify-content-between align-items-center mt-3">
                  <span>
                    Showing {page * rowsPerPage + 1} to{" "}
                    {Math.min((page + 1) * rowsPerPage, filteredHotels.length)}{" "}
                    of {filteredHotels.length} entries
                  </span>
                  <div>
                    <button
                      className="btn btn-default btn-sm mr-2"
                      onClick={() => handleChangePage(Math.max(0, page - 1))}
                      disabled={page === 0}
                    >
                      Prev
                    </button>
                    <button
                      className="btn btn-default btn-sm"
                      onClick={() =>
                        handleChangePage(
                          Math.min(
                            Math.floor(filteredHotels.length / rowsPerPage),
                            page + 1
                          )
                        )
                      }
                      disabled={
                        (page + 1) * rowsPerPage >= filteredHotels.length
                      }
                    >
                      Next
                    </button>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="modal fade" id="hotelInfo" tabindex="-1" role="dialog" aria-hidden="true">
                  <div className="modal-dialog modal-lg">
                     <div className="modal-content">
                        <div className="modal-header modal-header-primary">
                           <h3><i className="fa fa-building m-r-5"></i> Hotel Information</h3>
                           <button type="button" className="close" data-dismiss="modal" aria-hidden="true">×</button>
                        </div>
                       <div className="modal-body">
                        <table className="table px-3">                           
                           <tbody>
                             <tr>                            
                               <td>
                                 <p className="mb-1"><strong> Hotel Name </strong></p>
                                 <p className="mb-0">{hotel?.name}</p>
                               </td>
                               <td>
                                 <p className="mb-1"><strong> Hotel Address </strong></p>
                                 <p className="mb-0">{hotel?.address}</p>
                               </td>
                             </tr>

                             <tr>
                              <td>
                                <p className="mb-1"><strong> State </strong></p>
                                <p className="mb-0">{hotel?.state}</p>
                              </td>
                              <td>
                                 <p className="mb-1"><strong> Hotel Category  </strong></p>
                                 <p className="mb-0">{hotel?.category}</p>
                               </td>
                             
                            </tr>

                            <tr >
                              <td>
                                 <p className="mb-1"><strong> Contact Person Name </strong></p>
                                 <p className="mb-0">{hotel?.contact_person_name}</p>
                               </td>
                              <td>
                                <p className="mb-1"><strong> Contact Person Phone No </strong></p>
                                <p className="mb-0">+91 {hotel?.contact_number}</p>
                              </td>
                            </tr>
                            
                            <tr >
                              <td>
                                 <p className="mb-1"><strong>	Contact Person Email id </strong></p>
                                 <p className="mb-0">{hotel?.email}</p>
                               </td>
                             
                            </tr>

                           </tbody>
                         </table>
                        </div> 
                        <div className="modal-footer">
                           <button type="button" className="btn btn-danger float-left" data-dismiss="modal">Close</button>
                        </div>
                     </div>                     
                  </div>                
        </div>

        {showDeleteModal && (
        <div className="modal fade show d-block" tabIndex="-1" role="dialog">
          <div
            className="modal-dialog modal-lg"
            role="document"
            style={{ zIndex: "9999" }}
          >
            <div className="modal-content">
              <div className="modal-header modal-header-primary">
                <h3>
                  <i className="fa fa-user m-r-5"></i> Delete Hotels
                </h3>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-hidden="true"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  ×
                </button>
              </div>
              <div className="modal-body">
                <div className="row">
                  <div className="col-md-12">
                    <form className="form-horizontal">
                      <div className="row">
                        <div className="col-md-12 form-group user-form-group">
                          <label className="control-label">Delete Hotels</label>
                          <div className="float-right">
                            <button
                              type="button"
                              className="btn btn-danger btn-sm mr-3"
                              onClick={(e) => {
                                e.stopPropagation();
                                setShowDeleteModal(false);
                              }}
                            >
                              NO
                            </button>
                            <button
                              type="button"
                              className="btn btn-add btn-sm"
                              onClick={(e) => {
                                e.stopPropagation();
                                confirmDeleteHotel();
                              }}
                            >
                              YES
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-danger float-left"
                  data-dismiss="modal"
                  onClick={(e) => {
                    setShowDeleteModal(false);
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

    </>
  );
};

export default HotelsList;
